import React, { useContext, useEffect, useReducer, useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Tab from "react-bootstrap/esm/Tab";
import Tabs from "react-bootstrap/esm/Tabs";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import LoadingBox from "../components/LoadingBox";
import { default as config } from "../config.json";
import useAxios from "../hooks/useAxios";
import {
  capitalize,
  getError,
  turkishCurrencyFormatterNoPrecision,
  units,
} from "../utils";

import { Col, Row } from "react-bootstrap";
import ListGroup from "react-bootstrap/esm/ListGroup";
import ReactSelect from "react-select";
import FiliskaCarousel from "../components/FiliskaCarousel";
import Gorsel from "../components/Gorsel";
import Option from "../components/Option";
import OrderFirstOrderProducts from "../components/OrderFirstOrderProducts";
import ProductFeatures from "../components/ProductFeatures";
import ProductPermissions from "../components/ProductPermissions";
import ProductQuestions from "../components/ProductQuestions";
import useProductsAndCategories from "../hooks/useProductsAndCategories";
import ProductStockScreen from "./ProductStockScreen";

const reducer = (state, action) => {
  switch (action.type) {
    case "CREATE_REQUEST":
      return { ...state, loadingCreate: true };
    case "CREATE_SUCCESS":
      return {
        ...state,
        loadingCreate: false,
      };
    case "CREATE_FAIL":
      return { ...state, loadingCreate: false };
    case "UPDATE_REQUEST":
      return { ...state, loadingUpdate: true };
    case "UPDATE_SUCCESS":
      return { ...state, loadingUpdate: false };
    case "UPDATE_FAIL":
      return { ...state, loadingUpdate: false };
    case "UPLOAD_REQUEST":
      return { ...state, loadingUpload: true, errorUpload: "" };
    case "UPLOAD_SUCCESS":
      return {
        ...state,
        loadingUpload: false,
        errorUpload: "",
      };
    case "UPLOAD_FAIL":
      return { ...state, loadingUpload: false, errorUpload: action.payload };

    case "DELETE_FILE_REQUEST":
      return { ...state, dele: true, loadingDeletingImage: true };
    case "DELETE_FILE_SUCCESS":
      return {
        ...state,
        loadingDeletingImage: false,
      };
    case "DELETE_FILE_FAIL":
      return { ...state, loadingDeletingImage: false };

    default:
      return state;
  }
};
export default function ProductEditScreen(props) {
  const { isTabletOrMobile, product, setShowProductEditor } = props;
  const axios = useAxios();
  const params = useParams(); // /product/:id

  const { state } = useContext(Store);
  const { userInfo, allCategories, products } = state;
  const [{ loadingUpdate, loadingCreate }, dispatch] = useReducer(reducer, {
    loadingDeletingImage: false,
    loadingUpload: false,
    loadingCreate: false,
  });

  const [name, setName] = useState("");
  const [no, setNo] = useState("");

  const [price, setPrice] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [cost, setCost] = useState(0);
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [isMenu, setIsMenu] = useState(true);
  const [isStock, setIsStock] = useState(false);
  const [isStockOutSelf, setIsStockOutSelf] = useState(false);
  const [unit, setUnit] = useState("ADET-1");
  const [formValidated, setFormValidated] = useState(false);
  const [features, setFeatures] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [activeTab, setActiveTab] = useState(props.activeTab || "main");
  const [isCustomerFirstOrder, setIsCustomerFirstOrder] = useState(false);
  const [isCustomerSecondOrder, setIsCustomerSecondOrder] = useState(false);
  const [isHalfPortion, setIsHalfPortion] = useState(false);
  const [customerCantSee, setCustomerCantSee] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCategoriesNames, setSelectedCategoriesNames] = useState([]);
  const [firstOrderProducts, setFirstOrderProducts] = useState([]);
  const [stockInputs, setStockInputs] = useState([]);
  const navigate = useNavigate();

  const [, , setLoadProducts, setLoadCategories] = useProductsAndCategories();

  useEffect(() => {
    if (product._id) {
      setName(product.name);
      setNo(product.no);
      setSalePrice(product.price || "");
      setCost(product.cost);
      setPrice(product.price);
      setImage(product.image);
      setDescription(product.description || product.name);
      setIsMenu(product.isMenu);
      setIsStock(product.isStock);
      setUnit(product.unit);
      setFeatures(product.features ? product.features : []);
      setIsStockOutSelf(product.isStockOutSelf);
      setIsCustomerFirstOrder(product.isCustomerFirstOrder);
      setIsCustomerSecondOrder(product.isCustomerSecondOrder);
      setIsHalfPortion(product.isHalfPortion);
      setCustomerCantSee(product.customerCantSee);
      setQuestions(product.questions || []);

      const productCategories = allCategories.filter(
        (c) => c.products.filter((p) => p._id === product._id).length > 0
      );

      setSelectedCategories(productCategories.map((c) => c._id));
      setSelectedCategoriesNames(productCategories.map((c) => c.name));
      setFirstOrderProducts([
        ...products
          .filter((p) => p.isCustomerFirstOrder)
          .sort((p1, p2) => p1.orderOfFirstOrder - p2.orderOfFirstOrder),
      ]);
    }
  }, [product]);

  const submitHandler = async (e) => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      setFormValidated(true);
      return;
    }

    e.preventDefault();

    const questionsMustHaveProductChoices = questions
      .filter((q) => !q.deleted)
      .filter(
        (q) => q.answers.filter((a) => !a.deleted && a.product).length > 0
      );
    const emptyProductChoiceGiven = questionsMustHaveProductChoices.filter(
      (q) => q.answers.filter((a) => !a.deleted && !a.product).length > 0
    );

    if (emptyProductChoiceGiven.length > 0) {
      toast.error(
        "Lütfen menü sorularının cevaplarını kontrol ediniz. Bazı cevaplar için ürün seçmediniz!",
        { autoClose: 10000 }
      );
      return;
    }

    try {
      dispatch({ type: "UPDATE_REQUEST" });
      await axios.put(`/api/products/${product._id}`, {
        _id: product._id,
        name,
        description,
        no,
        slug: name,
        price: features.length > 0 ? 0 : price,
        expenseSubType:
          selectedCategoriesNames.length > 0
            ? selectedCategoriesNames[0]
            : "DIGER",
        image: image || config.default_image,
        isMenu,
        isStock,
        unit,
        salePrice: features.length > 0 ? 0 : !salePrice ? 0 : salePrice,
        features: features.filter((f) => f._id || !f.deleted),
        isStockOutSelf,
        isCustomerFirstOrder,
        isCustomerSecondOrder,
        isHalfPortion,
        customerCantSee,
        categories: selectedCategories,
        questions,
      });

      if (firstOrderProducts.length > 0) {
        await axios.put(`/api/products/admin/first_order`, {
          products: firstOrderProducts,
        });
        dispatch({
          type: "UPDATE_SUCCESS",
        });
      }

      dispatch({
        type: "UPDATE_SUCCESS",
      });
      setShowProductEditor(false);
      setLoadProducts(true);
      setLoadCategories(true);
      toast.success("Ürün başarılı bir şekilde güncellendi");
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };

  const createHandler = async (e) => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      setFormValidated(true);
      return;
    }
    e.preventDefault();

    try {
      dispatch({ type: "CREATE_REQUEST" });
      const { data } = await axios.post("/api/products", {
        name,
        slug: name,
        price,
        image: image || config.default_image,
        description,
        isMenu,
        isStock,
        unit,
        salePrice: !salePrice ? 0 : salePrice,
        features: features.filter((f) => f._id || !f.deleted),
        isStockOutSelf,
        categories: selectedCategories,
        isCustomerFirstOrder,
        isCustomerSecondOrder,
        isHalfPortion,
        customerCantSee,
        questions,
      });
      toast.success("Ürün başarılı bir şekilde oluşturuldu!");
      dispatch({ type: "CREATE_SUCCESS" });
      setShowProductEditor(false);
      setLoadCategories(true);
      setLoadProducts(true);
    } catch (err) {
      toast.error(getError(err));
      dispatch({
        type: "CREATE_FAIL",
      });
    }
  };

  const productFeaturesChangeHandler = (e, id, prop, i) => {
    if (!id) {
      const featuresCopied = [...features.filter((a) => !a.deleted)];
      if (prop === "name") {
        featuresCopied[i].name = e.target.value;
      } else {
        featuresCopied[i].price = Number(e.target.value);
      }
      setFeatures([
        ...featuresCopied,
        ...features.filter((a) => a.deleted && a._id),
      ]);
      return;
    }
    const lastFeautures = features
      .filter((f) => !f.deleted)
      .map((f, i) => {
        if (f._id === id) {
          if (prop === "name") {
            f.name = e.target.value;
          } else {
            f.price = Number(e.target.value);
          }
        }
        return f;
      });
    setFeatures([...lastFeautures]);
  };

  const productQuestionAnswerChangeHandler = (e, ai, q, qi, field) => {
    const question = { ...q };
    const answers = question.answers;

    const answersDeleted = [...answers.filter((f) => f.deleted)];

    question.answers = [...answers.filter((f) => !f.deleted)].map((a, i) => {
      if (i === ai) {
        const ans = { ...a };
        ans[field] = e.target.value;
        return ans;
      } else {
        return { ...a };
      }
    });
    question.answers.push(...answersDeleted);

    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);
    const result = questionsNotDeleted.map((q, i) => {
      if (i === qi) {
        return { ...question };
      } else {
        return { ...q };
      }
    });
    result.push(...questionsDeleted);
    setQuestions(result);
  };

  const productQuestionAnswerWithProductChangeHandler = (
    ai,
    q,
    qi,
    product,
    feature
  ) => {
    const question = { ...q };
    const answers = question.answers;

    const answersDeleted = [...answers.filter((f) => f.deleted)];

    question.answers = answers
      .filter((f) => !f.deleted)
      .map((a, i) => {
        if (i === ai) {
          const ans = { ...a };
          ans.product = product._id;
          ans.feature = feature?._id;
          ans.image = product.image;
          ans.firstCost = (product?.price || 0) + (feature?.price || 0);
          ans.answer = feature
            ? feature.name + " " + product.name
            : product.name;
          ans.cost = (product?.price || 0) + (feature?.price || 0);
          return ans;
        } else {
          return { ...a };
        }
      });
    question.answers.push(...answersDeleted);

    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);
    const result = questionsNotDeleted.map((q, i) => {
      if (i === qi) {
        return { ...question };
      } else {
        return { ...q };
      }
    });
    result.push(...questionsDeleted);
    setQuestions(result);
  };

  const productFeaturesAddHandler = () => {
    setFeatures([...features, { name: "", price: null, deleted: false }]);
  };

  const productQuestionAnswerAddHandler = (i, question) => {
    const questionsRe = [...questions];
    questionsRe[i] = {
      ...question,
      answers: [...question.answers, { answer: "", deleted: false }],
    };

    setQuestions(questionsRe);
  };
  const productQuestionChangeHandler = (e, i, question) => {
    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);

    questionsNotDeleted[i] = {
      ...question,
      question: e.target.value,
    };
    questionsNotDeleted.push(...questionsDeleted);
    setQuestions(questionsNotDeleted);
  };

  const productQuestionMultiOptionChangeHandler = (e, i, question) => {
    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);

    questionsNotDeleted[i] = {
      ...question,
      multi: e.target.checked,
    };
    questionsNotDeleted.push(...questionsDeleted);
    setQuestions(questionsNotDeleted);
  };

  const productQuestionCompulsoryOptionChangeHandler = (e, i, question) => {
    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);

    questionsNotDeleted[i] = {
      ...question,
      compulsory: e.target.checked,
    };
    questionsNotDeleted.push(...questionsDeleted);
    setQuestions(questionsNotDeleted);
  };

  const productQuestionDeleteHandler = (id, i) => {
    if (!id) {
      const questionsRe = [...questions.filter((f) => !f.deleted)];
      const questionsDeleted = [...questions.filter((f) => f.deleted)];
      if (i + 1 === questionsRe.length) {
        setQuestions([...questions.slice(0, i), ...questionsDeleted]);
      } else {
        setQuestions([
          ...questionsRe.slice(0, i),
          ...questionsRe.slice(i + 1),
          ...questionsDeleted,
        ]);
      }
      return;
    } else {
      const questionsDeleted = [...questions.filter((f) => f.deleted)];
      const questionsRe = [...questions.filter((f) => !f.deleted)].map((q) => {
        if (q._id === id) {
          return { ...q, deleted: true };
        } else {
          return { ...q };
        }
      });
      setQuestions([...questionsRe, ...questionsDeleted]);
    }
  };

  const productFeaturesDeleteHandler = (id, i) => {
    if (!id) {
      const copyOfFeatures = [...features.filter((f) => !f.deleted)];
      copyOfFeatures[i].deleted = true;
      setFeatures([
        ...copyOfFeatures,
        ...features.filter((f) => f.deleted && f._id),
      ]);
      return;
    }
    setFeatures([
      ...features.map((f, index) => {
        if (f._id === id) {
          return { ...f, deleted: true };
        } else {
          return { ...f };
        }
      }),
    ]);
  };

  const productQuestionAnswerDeleteHandler = (answerId, answerIndex, q, qi) => {
    const question = { ...q };
    const answers = question.answers;
    if (!answerId) {
      const answersRe = [...answers.filter((f) => !f.deleted)];
      const answersDeleted = [...answers.filter((f) => f.deleted)];
      if (answerIndex + 1 === answersRe.length) {
        question.answers = [...answers.slice(0, answerIndex)];
      } else {
        question.answers = [
          ...answersRe.slice(0, answerIndex),
          ...answersRe.slice(answerIndex + 1),
        ];
      }
      question.answers.push(...answersDeleted);
    } else {
      const answersDeleted = [...answers.filter((f) => f.deleted)];
      question.answers = [...answers.filter((f) => !f.deleted)].map((a) => {
        if (a._id === answerId) {
          return { ...a, deleted: true };
        } else {
          return { ...a };
        }
      });
      question.answers.push(...answersDeleted);
    }
    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);
    const result = questionsNotDeleted.map((q, i) => {
      if (i === qi) {
        return { ...question };
      } else {
        return { ...q };
      }
    });
    result.push(...questionsDeleted);
    setQuestions(result);
  };

  return (
    <Container className="small-container">
      <Helmet>
        <title>{name}</title>
      </Helmet>

      <Form
        onSubmit={!product._id ? createHandler : submitHandler}
        noValidate
        validated={formValidated}
      >
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          <Tab eventKey="main" title="Detaylar">
            <Form.Group className="mb-3">
              <Row>
                <Col md="8">
                  <Form.Label>Adı</Form.Label>
                  <Form.Control
                    placeholder="Ürün Adı"
                    value={name}
                    onChange={(e) => setName(capitalize(e.target.value))}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Lutfen ad alanini bos birakmayiniz
                  </Form.Control.Feedback>
                </Col>
                <Col md="4">
                  <Form.Label>No</Form.Label>
                  <Form.Control
                    placeholder="Ürün Numarası"
                    type="number"
                    value={no}
                    onChange={(e) =>
                      setNo(e.target.value ? Number(e.target.value) : "")
                    }
                    min={0}
                    pattern="^[0-9]*$"
                  />
                  <Form.Control.Feedback type="invalid">
                    Lutfen bu ürüne hatırlayabileceğiniz basit bir numara
                    veriniz.
                  </Form.Control.Feedback>
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Açıklama</Form.Label>
              <Form.Control
                placeholder="Ürün Açıklaması"
                as="textarea"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
              <Form.Control.Feedback type="invalid">
                Lutfen acıklama alanini bos birakmayiniz
              </Form.Control.Feedback>
            </Form.Group>

            {false && (
              <Form.Group className="mb-3">
                <Form.Label>Birimi</Form.Label>
                <Form.Select
                  value={unit}
                  onChange={(e) => {
                    setUnit(e.target.value);
                    if (e.target.value === "ADET-1") {
                      setIsStock(true);
                    }
                  }}
                >
                  {units.map((c) => (
                    <option value={c.type} key={c.type}>
                      {c.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}

            <div className="mb-3">
              <div className="mb-2">
                <Button
                  className=" mb-0"
                  onClick={() => productFeaturesAddHandler()}
                >
                  <i className="fas fa-plus"></i> Çeşit Ekle
                </Button>
              </div>
              <ProductFeatures
                productFeaturesAddHandler={productFeaturesAddHandler}
                productFeaturesChangeHandler={productFeaturesChangeHandler}
                productFeaturesDeleteHandler={productFeaturesDeleteHandler}
                features={features}
                isStockExist={stockInputs.length > 0}
              ></ProductFeatures>
            </div>

            {features.filter((f) => !f.deleted).length == 0 && (
              <Form.Group className="mb-3">
                <Row>
                  <Col md={8}>
                    <Form.Label>Satış Fiyatı</Form.Label>

                    <Form.Control
                      placeholder="Satış Fiyatı"
                      value={salePrice}
                      type="number"
                      onChange={(e) => {
                        const value = e.target.value;

                        // Check if the input is valid and remove leading zeros
                        const sanitizedValue =
                          value.startsWith("0") && value.length > 1
                            ? value.replace(/^0+/, "")
                            : value;

                        setSalePrice(sanitizedValue);
                      }}
                      required
                    />
                  </Col>
                  <Col md={4}>
                    {cost > 0 && (
                      <Form.Label
                        className={features.length === 0 ? "" : "text-danger"}
                      >
                        Maliyet
                      </Form.Label>
                    )}

                    {cost > 0 && (
                      <Form.Control
                        disabled={true}
                        value={cost}
                        type="number"
                        required
                      />
                    )}
                  </Col>
                </Row>
              </Form.Group>
            )}

            <Gorsel
              image={image}
              setImage={setImage}
              entityId={product._id}
              entityName={"product"}
            ></Gorsel>

            <Form.Group className="mb-3">
              <Form.Label>Kategoriler</Form.Label>
              <div className="mb-3">
                <ReactSelect
                  placeholder="Kategori Seç"
                  options={allCategories.map((c) => {
                    return { value: c._id, label: c.name };
                  })}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  onChange={(selected) => {
                    setSelectedCategories(selected.map((entry) => entry.value));
                    setSelectedCategoriesNames(
                      selected.map((entry) => entry.label)
                    );
                  }}
                  allowSelectAll={true}
                  value={allCategories
                    .filter((c) => selectedCategories.includes(c._id))
                    .map((c) => {
                      return { value: c._id, label: c.name };
                    })}
                />
              </div>
            </Form.Group>
          </Tab>
          <Tab eventKey="permissions" title="İzinler">
            <ProductPermissions
              isMenu={isMenu}
              setIsMenu={setIsMenu}
              isCustomerFirstOrder={isCustomerFirstOrder}
              setIsCustomerFirstOrder={setIsCustomerFirstOrder}
              isCustomerSecondOrder={isCustomerSecondOrder}
              setIsCustomerSecondOrder={setIsCustomerSecondOrder}
              isHalfPortion={isHalfPortion}
              setIsHalfPortion={setIsHalfPortion}
              customerCantSee={customerCantSee}
              setCustomerCantSee={setCustomerCantSee}
              setIsStock={setIsStock}
              isStock={isStock}
              isStockOutSelf={isStockOutSelf}
              setIsStockOutSelf={setIsStockOutSelf}
            ></ProductPermissions>
          </Tab>

          <Tab eventKey="questions" title="Menü">
            <Button
              className="mb-3"
              onClick={() => {
                setQuestions([
                  ...questions,
                  {
                    question: "",
                    multi: false,
                    compulsory: false,
                    deleted: false,
                    answers: [
                      { answer: "", deleted: false },
                      { answer: "", deleted: false },
                    ],
                  },
                ]);
              }}
            >
              <i className="fas fa-plus"></i> {"Soru Ekle"}
            </Button>

            {questions
              .filter((q) => !q.deleted)
              .map((q, i) => (
                <ProductQuestions
                  key={q._id ? q._id : i + ""}
                  productQuestionCompulsoryOptionChangeHandler={
                    productQuestionCompulsoryOptionChangeHandler
                  }
                  productQuestionAnswerWithProductChangeHandler={
                    productQuestionAnswerWithProductChangeHandler
                  }
                  productQuestionMultiOptionChangeHandler={
                    productQuestionMultiOptionChangeHandler
                  }
                  productQuestionDeleteHandler={productQuestionDeleteHandler}
                  productQuestionChangeHandler={productQuestionChangeHandler}
                  productQuestionAnswerChangeHandler={
                    productQuestionAnswerChangeHandler
                  }
                  productQuestionAnswerDeleteHandler={
                    productQuestionAnswerDeleteHandler
                  }
                  productQuestionAnswerAddHandler={
                    productQuestionAnswerAddHandler
                  }
                  question={q}
                  questionIndex={i}
                  setShowProductEditor={setShowProductEditor}
                ></ProductQuestions>
              ))}
          </Tab>
          {false && isStock && product._id && (
            <Tab eventKey="stokGir" title="Stok Girisi">
              <ProductStockScreen
                productId={product._id}
                stockInputs={stockInputs}
                setStockInputs={setStockInputs}
              ></ProductStockScreen>
            </Tab>
          )}
          {false && (
            <Tab eventKey="panorama" title="Panorama">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="m-3">
                  <FiliskaCarousel
                    panorama
                    products={[
                      {
                        _id: product._id,
                        name,
                        slug: name,
                        price,
                        image,
                        description,
                        isMenu,
                        isStock,
                        unit,
                        salePrice,
                        features,
                        isStockOutSelf,
                        isCustomerFirstOrder,
                        isCustomerSecondOrder,
                        isHalfPortion,
                      },
                    ]}
                    setProduct={(p) => {}}
                    setFeature={(f) => {}}
                    setFeatures={(fs) => {}}
                    setRoot={(r) => {}}
                  ></FiliskaCarousel>
                </div>

                <div className="m-3">
                  <ListGroup>
                    {features && features.length > 0 && (
                      <>
                        {features
                          .filter((f) => !f.deleted)
                          .map((f) => {
                            return (
                              <ListGroup.Item>
                                <div>
                                  <h5 style={{ display: "inline" }}>
                                    {f.name.startsWith("Normal")
                                      ? salePrice
                                      : f.name + " " + name}
                                  </h5>
                                  &nbsp;&nbsp;&nbsp;
                                  <span>
                                    {turkishCurrencyFormatterNoPrecision(
                                      salePrice
                                    )}
                                  </span>
                                </div>
                              </ListGroup.Item>
                            );
                          })}
                      </>
                    )}
                  </ListGroup>
                </div>
              </div>
            </Tab>
          )}
          {isCustomerFirstOrder && product._id && (
            <Tab eventKey="ordering" title="Sırala">
              <div>
                <span className="text-muted">
                  Müşteri ekranında gösterilecek olan ürünlerin sıralaması
                  aşağıdaki gibidir.
                </span>
              </div>
              <div className="mb-3">
                <span className="text-muted">
                  Değiştirmek için yukarı aşağı oklarını kullanınız.
                </span>
              </div>
              <OrderFirstOrderProducts
                firstOrderProducts={firstOrderProducts}
                setFirstOrderProducts={setFirstOrderProducts}
                productSelected={product._id}
              ></OrderFirstOrderProducts>
            </Tab>
          )}
        </Tabs>

        <div className="mb-3 mt-3">
          <Button disabled={loadingUpdate || loadingCreate} type="submit">
            <i className="fa fa-save"></i>&nbsp; Kaydet
          </Button>
          &nbsp;
          <Button
            variant="light"
            className="text-danger border-danger"
            disabled={loadingUpdate || loadingCreate}
            onClick={() => {
              setShowProductEditor(false);
            }}
          >
            Kapat
          </Button>
          {loadingUpdate && <LoadingBox></LoadingBox>}
        </div>
      </Form>
    </Container>
  );
}
